import { put, takeLatest } from "redux-saga/effects";

import { setCurrentUser2FA } from "modules/auth";

import { callApi } from "../../../sagas/helpers/api";
import {
  enqueueSnackbarSuccess,
  setError,
  setSuccess,
  startLoading,
} from "../../../store/appSlice";
import * as TwoFactorApi from "../api/TwoFactorApi";
import {
  disableCurrentUser2FA,
  enableTwoFA,
  getQRCode,
  operationPath,
  setQrCode,
} from "./index";

import type { PayloadAction } from "@reduxjs/toolkit";
import type { TwoFAConfirmationCode } from "../models/TwoFAConfirmationCode";

function* getQRCodeSaga() {
  yield put(startLoading(operationPath.qrCode));

  try {
    const response: SVGAElement = yield callApi(
      TwoFactorApi.postTwoFactorGenerate
    );

    yield put(setQrCode(response));
    yield put(setSuccess(operationPath.qrCode));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath.qrCode,
        error,
      })
    );
  }
}

function* disableCurrentUser2FASaga({
  payload,
}: PayloadAction<TwoFAConfirmationCode>) {
  const { code } = payload;

  yield put(startLoading(operationPath.disableTwoFA));

  try {
    yield callApi(TwoFactorApi.postDisableCurrentUser2FA, {
      code,
    });
    yield put(setCurrentUser2FA(false));
    yield put(
      enqueueSnackbarSuccess({
        code: "Two-factor authentication was deactivated.",
      })
    );
    yield put(setSuccess(operationPath.disableTwoFA));
  } catch (error) {
    yield put(
      setError({
        path: operationPath.disableTwoFA,
        error,
      })
    );
  }
}

function* enableTwoFASaga({ payload }: PayloadAction<typeof enableTwoFA>) {
  yield put(startLoading(operationPath.enableTwoFA));

  try {
    yield callApi(TwoFactorApi.postEnableCurrentUser2FA, payload);
    yield put(setSuccess(operationPath.enableTwoFA));
    yield put(setCurrentUser2FA(true));
    yield put(
      enqueueSnackbarSuccess({
        code: "Two-factor authentication has been activated.",
      })
    );
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath.enableTwoFA,
        error,
      })
    );
  }
}

export function* rootSaga() {
  yield takeLatest(getQRCode.type, getQRCodeSaga);
  yield takeLatest(enableTwoFA.type, enableTwoFASaga);
  yield takeLatest(disableCurrentUser2FA.type, disableCurrentUser2FASaga);
}
